import React from 'react';
import { useWallet } from '../../context/WalletContext';
import { CURRENT_NETWORK } from '../../config/network';
import MiniLoader from './MiniLoader';

const NetworkBanner = () => {
  const { connected, wrongNetwork, switchNetwork } = useWallet();
  const [switching, setSwitching] = React.useState(false);

  if (!connected || !wrongNetwork) return null;

  const doSwitch = async () => {
    setSwitching(true);
    try { await switchNetwork(); } finally { setSwitching(false); }
  };

  return (
    <div className="main-content" style={{ paddingBottom: 0 }}>
      <div className="wrong-network-banner">
        <div>
          <strong>⚠ Wrong Network</strong>
          <div style={{ fontSize: 13, marginTop: 4 }}>
            Please switch to {CURRENT_NETWORK.name} to use Dreamlifeway
          </div>
        </div>
        <button className="btn btn-error btn-sm" onClick={doSwitch} disabled={switching}>
          {switching ? <><MiniLoader /> Switching</> : 'Switch Network'}
        </button>
      </div>
    </div>
  );
};

export default NetworkBanner;
